import { ApolloClient, gql } from 'apollo-boost';
import { FeedbackSectionId } from 'donor/portal/pages/FeedbackDashboard/Feedback/utils';

const deleteSectionAnswersMutation = gql`
  mutation deleteSectionAnswers(
    $reportId: Int!
    $sectionId: String!
    $cascade: Boolean
    $soft: Boolean
  ) {
    deleteSectionAnswers(
      reportId: $reportId
      sectionId: $sectionId
      cascade: $cascade
      soft: $soft
    ) {
      success
    }
  }
`;

export interface DeleteSectionAnswersResponse {
  deleteSectionAnswers: {
    success: boolean;
  };
}

export interface DeleteSectionAnswersOptions {
  cascade?: boolean;
  soft?: boolean;
}

export const deleteSectionAnswers = (
  client: ApolloClient<object>,
  reportId: number,
  sectionId: FeedbackSectionId,
  { cascade = false, soft = false }: DeleteSectionAnswersOptions = {},
) => {
  return client.mutate<DeleteSectionAnswersResponse>({
    mutation: deleteSectionAnswersMutation,
    variables: { reportId, sectionId, cascade, soft },
    fetchPolicy: 'no-cache',
  });
};
